import { IconProp } from '@fortawesome/fontawesome-svg-core';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const Icon: React.FC<{ icon: IconProp, className?: string }> =
  ({ icon, className }) =>
    <FontAwesomeIcon icon={icon} className={className} />;

